import React, { useState } from 'react';
import { Button, Card, Form, Input, Result } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import Hero from 'components/Hero';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import useAuth from 'hooks/useAuth';

import messages from './messages';

const ForgotPassword = () => {
  const { formatMessage: $t } = useIntl();
  const { requestNewPassword } = useAuth();

  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      await requestNewPassword(values.email);

      setResult({
        status: 'success',
        title: $t(messages.successTitle),
        message: $t(messages.successMessage),
      });
    } catch (error) {
      setResult({
        status: 'error',
        title: $t(messages.errorTitle),
        message: $t(messages.errorMessage),
      });
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Hero branded>
      <Card>
        {result && (
          <Result
            status={result.status}
            title={result.title}
            subTitle={result.message}
          />
        )}
        {!result && (
          <Form onFinish={onFinish}>
            <p>Enter your email address and we will send you instructions to reset your password.</p>
            <Form.Item name="email" rules={[{ required: true, message: $t(messages.emailRequired) }]}>
              <Input
                type="email"
                prefix={<MailOutlined className="input-icon" />}
                placeholder={$t(messages.email)}
              />
            </Form.Item>
            <Form.Item>
              <Button block type="primary" htmlType="submit" loading={loading}>
                {$t(messages.submit)}
              </Button>
            </Form.Item>
          </Form>
        )}
        <Link to="/login">
          {$t(messages.login)}
        </Link>
      </Card>
    </Hero>
  );
};

export default ForgotPassword;
